// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see DetailsPageInteractViewPageEvent
 */
export var DetailsPageInteractViewPage = function (_a) {
    var detailsPageToken = _a.detailsPageToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken, origin = _a.origin;
    return ({
        name: "DetailsPage Interact ViewPage",
        parameters: {
            cdf_entity: "DetailsPage",
            cdf_action: "Interact",
            details_page_token: detailsPageToken !== undefined && detailsPageToken !== null ? detailsPageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DetailsPageInteractTapShareButtonEvent
 */
export var DetailsPageInteractTapShareButton = function (_a) {
    var detailsPageToken = _a.detailsPageToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "DetailsPage Interact TapShareButton",
        parameters: {
            cdf_entity: "DetailsPage",
            cdf_action: "Interact",
            details_page_token: detailsPageToken !== undefined && detailsPageToken !== null ? detailsPageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DetailsPageInteractShareCompletedEvent
 */
export var DetailsPageInteractShareCompleted = function (_a) {
    var detailsPageToken = _a.detailsPageToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken, shareOption = _a.shareOption, completed = _a.completed;
    return ({
        name: "DetailsPage Interact ShareCompleted",
        parameters: {
            cdf_entity: "DetailsPage",
            cdf_action: "Interact",
            details_page_token: detailsPageToken !== undefined && detailsPageToken !== null ? detailsPageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            share_option: shareOption !== undefined && shareOption !== null ? shareOption.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            completed: completed !== undefined && completed !== null ? completed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DetailsPageInteractScrollEvent
 */
export var DetailsPageInteractScroll = function (_a) {
    var detailsPageToken = _a.detailsPageToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "DetailsPage Interact Scroll",
        parameters: {
            cdf_entity: "DetailsPage",
            cdf_action: "Interact",
            details_page_token: detailsPageToken !== undefined && detailsPageToken !== null ? detailsPageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DetailsPageInteractTapButtonEvent
 */
export var DetailsPageInteractTapButton = function (_a) {
    var detailsPageToken = _a.detailsPageToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken, buttonText = _a.buttonText, buttonLocation = _a.buttonLocation;
    return ({
        name: "DetailsPage Interact TapButton",
        parameters: {
            cdf_entity: "DetailsPage",
            cdf_action: "Interact",
            details_page_token: detailsPageToken !== undefined && detailsPageToken !== null ? detailsPageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            button_text: buttonText !== undefined && buttonText !== null ? buttonText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            button_location: buttonLocation !== undefined && buttonLocation !== null ? buttonLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DetailsPageInteractDismissPageEvent
 */
export var DetailsPageInteractDismissPage = function (_a) {
    var detailsPageToken = _a.detailsPageToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "DetailsPage Interact DismissPage",
        parameters: {
            cdf_entity: "DetailsPage",
            cdf_action: "Interact",
            details_page_token: detailsPageToken !== undefined && detailsPageToken !== null ? detailsPageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
